export type KnowledgeBaseLanguage = "en" | "es";

export interface KbArticle {
  id: string;
  title: string;
  contentHtml: string;
}

export interface KbGroup {
  id: string;
  title: string;
  articles: KbArticle[];
}

export interface KbSection {
  id: string;
  title: string;
  introHtml?: string;
  articles: KbArticle[];
  groups: KbGroup[];
}

export interface KnowledgeBaseReturnContext {
  url: string;
  labelKey: string;
}

export const KNOWLEDGE_BASE_RETURN_STATE_KEY = "knowledgeBaseReturn";

export const KNOWLEDGE_BASE_ARTICLE_STATE_KEY = "kbArticleId";

export const DEFAULT_KNOWLEDGE_BASE_RETURN: KnowledgeBaseReturnContext = {
  url: "/dashboard",
  labelKey: "knowledge_base.return.dashboard",
};
